const cookieDefaultValues = {
  expires: 7,
  path: '/',
  domain: window.location.hostname,
};

class Cookies {
  constructor(options = {}) {
    this.options = {
      ...cookieDefaultValues,
      ...options,
    };
  }

  /**
   * Write cookie
   * @param value - String
   */
  write(value) {
    document.cookie = `${this.options.name}=${value}; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
  }

  /**
   * Read cookies and returns an array of values
   * @returns Array
   */
  read() {
    let cookieValuesArr = [];
    const hasCookieWithThisName = document.cookie.split('; ').find((row) => row.startsWith(this.options.name));

    if (document.cookie.indexOf('; ') !== -1 && hasCookieWithThisName) {
      const cookieValue = document.cookie
        .split('; ')
        .find((row) => row.startsWith(this.options.name))
        .split('=')[1];

      if (cookieValue !== null) {
        cookieValuesArr = cookieValue.split(',');
      }
    }

    return cookieValuesArr;
  }

  destroy() {
    document.cookie = `${this.options.name}=null; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
  }

  remove(removedValue) {
    const cookieValue = this.read();
    const position = cookieValue.indexOf(removedValue);

    if (position !== -1) {
      cookieValue.splice(position, 1);
      this.write(cookieValue);
    }
  }
}

export default Cookies;
